interface TransactionFormEntryState {
  transactionTypeInUse?: boolean;
  isPostingPeriodLocked: boolean;
  isParametersLoading: boolean;
  isPostingPeriodLoading: boolean;
}

const ENTRY_FOCUS = { 'data-entry-focus': true } as const;
const NO_MARKER = {};

/**
 * Marks where the form starts for keyboard entry: the transaction type when it can be filled in,
 * otherwise the subject. Until the parameters and posting period that decide it have loaded, the
 * form is marked as pending instead, so focus never lands on the subject only to be taken back.
 */
export const getTransactionFormEntryMarkers = ({
  transactionTypeInUse,
  isPostingPeriodLocked,
  isParametersLoading,
  isPostingPeriodLoading,
}: TransactionFormEntryState) => {
  const startsOnTransactionType = Boolean(transactionTypeInUse) && !isPostingPeriodLocked;
  const isDeciding = isParametersLoading || isPostingPeriodLoading;
  return {
    form: isDeciding ? { 'data-entry-pending': true } : NO_MARKER,
    transactionType: startsOnTransactionType ? ENTRY_FOCUS : NO_MARKER,
    subject: startsOnTransactionType ? NO_MARKER : ENTRY_FOCUS,
  };
};
